import { render, staticRenderFns } from "./CostModuleTab.vue?vue&type=template&id=de1528d4&"
import script from "./CostModuleTab.vue?vue&type=script&lang=js&"
export * from "./CostModuleTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports